import Immutable from "immutable";
import { Client } from "resourceModels";

export default class ZendeskAgentWorkspacePlatformRecord extends Immutable.Record({
  name: "zaw_liveagent",
  fullName: "Zendesk Social Messaging",
  enabled: false,
  auth: Immutable.Map({
    appId: "",
    apiKey: "",
    apiSecret: "",
    subdomain: "",
    email: "",
    apiToken: ""
  }),

  isVisibleToClient(client: Client): boolean {
    return client.features.get("zendeskAgentWorkspace");
  }
}) {}
